<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline :title="assessmentID ? 'Edit Assessment' : 'Add Assessment'"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{assessmentID ? 'Edit Assessment' : 'Add Assessment'}}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'teacherAssessment' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="selectedClassID" :items="classData" item-text="name" item-value="id" label="Select Class Group" :rules="classRules" @input="getModuleData()"></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.trainingModuleID" :items="moduleData" item-text="name" item-value="id" label="Select module" :rules="classRules"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" md="6" v-if="getList.length > 0"><span id="abcd">Classes:</span><br>
              <v-chip-group column>
                <v-chip small color="accent"
                v-for='name in getList'
                :key="name"
                  >
                  {{ name }}
                </v-chip>
              </v-chip-group>
              </v-col>
            <!-- <v-col cols="12" lg="6" v-if="getList.length > 0"><b>Classes</b> :<br> {{ getList }}</v-col> -->
            <v-col cols="12" lg="3" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.assessmentType" :items="assessmentTypeData" label="Assessment Type" :rules="classRules"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12"  lg="2" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.passingPercentage" :items="passPercentageData" label="Passing percentage %" :rules="classRules"></v-autocomplete>
            </v-col> -->
            <v-col cols="12" lg="2" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.durationMin" :items="durationData" label="Duration (Min)" :rules="classRules"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" md="6">
              <v-text-field hide-details class="my-0 py-1" label="No. of questions to appear in Test" v-model="formData.noOfQuestionsAppearForTest" type="number"  required></v-text-field>
            </v-col>
            <v-col cols="12" lg="3" md="6">
              <v-autocomplete hide-details class="my-0 py-1" v-model="formData.attempts" :items="attemptsData" type="number" label="Attempts" :rules="classRules"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" md="6">
              <v-text-field hide-details class="my-0 py-1" label="Question" v-model.trim="questionObj.question" required></v-text-field>
            </v-col>
<v-col cols="12" md="12">
              Description:
              <ckeditor required v-model="questionObj.description" ref="ckeditorRef"></ckeditor>
            </v-col>
            <v-col hide-details class="my-0 py-1" v-for="(option, index) in questionObj.options" :key="index" cols="12" md="3">
              <v-text-field :label="`Option${index + 1}`" v-model.trim="option.option" hide-details="auto" required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete clearable multiple hide-details class="my-0 py-1" v-model="questionObj.selectedOption" :items="correctOption" label="Correct Option" @input="setSelectedOption()"></v-autocomplete>
            </v-col>
            <v-col cols="12"  md="6">
              <v-btn small hide-details class="my-0 py-1 ml-3 mt-4"  elevation="1" color="primary" @click="addOptions()">
                Add Options
              </v-btn>
              <v-btn small hide-details class="my-0 py-1 ml-3 mt-4"  elevation="1" color="primary" @click="deleteOptions()">
                Delete Options
              </v-btn>
              <v-btn small hide-details class="my-0 py-1 ml-3 mt-4"  elevation="1" color="primary" @click="addQuestion()">
                Add Question
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="questions.length">
              <v-data-table :headers="dynamicHeaders" :items="questions" :items-per-page="10">
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.position }}</td>
                    <td>{{ props.item.question }}</td>
                    <td>
                      <div v-html="props.item.description"></div>
                    </td>
                    <td>{{ renderSelectedOptions(props.item.selectedOption) }}</td>
                    <template v-for="index in (maxOptionsCount > optionsCount ? maxOptionsCount : optionsCount)">
                      <td :key="`option-${index}`">{{ getOptionValue(props.item, `op${index}`) || '' }}</td>
                    </template>
                    <td class="text-center">
                      <v-btn @click="editItem(props.item)" class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn v-if="props.item.isActive" @click="deleteItem(props.item)" class="px-2 ml-1 white--text ma-1" color="error" min-width="0" small>
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn v-if="!props.item.isActive" @click="restoreItem(props.item)" class="px-2 ml-1 white--text ma-1" color="success" min-width="0" small>
                        <v-icon small>mdi-restore</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-spacer />
                <v-btn depressed color="primary" @click="onSubmit">
                  Save Assessment
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      </v-card>
    <!-- </material-card> -->
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
// import VCardComponent from '@/components/template/VCardComponent'

import _ from 'lodash'
// import moment from 'moment'
import { mapGetters } from 'vuex'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)

export default {
  name: 'TeacherAssessment',
  // components: { VCardComponent },
  props: ['assessmentID'],
  data () {
    return {
      tab: null,
      activeTab: 0,
      items: [],
      questions: [],
      data: [],
      valid: false,
      assessmentTypeData: ['MCQ'],
      passPercentageData: [70],
      attemptsData: [2, 3, 4, 5],
      durationData: [10, 20, 30, 40, 50, 60],
      correctOption: [1, 2, 3, 4],
      classRules: [v => !!v || 'Item is required'],
      formData: {
        trainingModuleID: '',
        description: '',
        assessmentType: 'MCQ',
        passingPercentage: 70,
        attempts: '',
        durationMin: '',
        noOfQuestionsAppearForTest: '',
        questions: []
      },
      getList: [],
      isEdit: false,
      selectedID: null,
      moduleData: [],
      classData: [],
      selectedClassID: null,
      questionObj: {
        question: '',
        description: '',
        position: '',
        selectedOption: '',
        isActive: true,
        options: [
          {
            option: '',
            position: 1,
            isCorrect: false
          },
          {
            option: '',
            position: 2,
            isCorrect: false
          },
          {
            option: '',
            position: 3,
            isCorrect: false
          },
          {
            option: '',
            position: 4,
            isCorrect: false
          }
        ]
      },
      headers: [
        { text: 'Question position', sortable: false, value: 'position' },
        { text: 'Question', sortable: false, value: 'question' },
        { text: 'Description', sortable: false, value: 'description' },
        { text: 'Correct Option', sortable: false, value: 'selectedOption' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      maxOptionsCount: 0,

      isLoading: false
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    optionsCount () {
      return this.questions.reduce((max, question) => {
        const optionsLength = question.options ? question.options.length : 0
        return Math.max(max, optionsLength)
      }, 0)
    },
    dynamicHeaders () {
      const maxOptions = Math.max(this.optionsCount, this.maxOptionsCount)
      const dynamicOptionHeaders = Array.from({ length: maxOptions }, (_, index) => ({
        text: `Option ${index + 1}`,
        sortable: false,
        value: `op${index + 1}`
      }))
      return [...this.headers.slice(0, 4), ...dynamicOptionHeaders, this.headers.slice(-1)[0]]
    }
  },
  mounted: async function () {
    this.updateCorrectOptions()
    this.updateDynamicHeaders()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    'questionObj.options': {
      handler: 'updateCorrectOptions',
      deep: true
    },
    optionsCount (newVal) {
      this.updateDynamicHeaders()
    },
    maxOptionsCount (newVal) {
      this.updateDynamicHeaders()
    }
  },
  async created () {
    try {
      await this.getClassData()
      if (this.assessmentID) {
        await this.getAssessmentData(this.assessmentID)
      }
      // this.isWrite = Utils.helper.getIsWriteFun(this.$route)
      // this.isLoading = true
    } catch (error) {
      console.log(error)
    }
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix
    const that = this.$refs.ckeditorRef
    const maximizedState = that.instance.getCommand('maximize').state
    if (maximizedState === 1) {
      that.instance.execCommand('maximize')
    }
    if (this.hasDataChanged() && !this.hasClicked) {
      return this.$buefy.dialog.confirm({
        title: 'Leave Page',
        message: 'Do you really want to leave? you have unsaved changes!',
        type: 'is-danger',
        cancelText: 'No',
        confirmText: 'Yes',
        onConfirm: () => {
          next()
        },
        onCancel: () => {
          next(false)
        }
      })
    } else next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    renderSelectedOptions (selectedOptions) {
      return selectedOptions ? selectedOptions.join(', ') : ''
    },
    updateDynamicHeaders () {
      this.$forceUpdate() // Forces Vue to re-render the component
    },
    getOptionValue (item, optionKey) {
      const optionIndex = parseInt(optionKey.replace('op', ''), 10) - 1
      const optionsArray = item.id ? item.trainingQuestionOptions : item.options
      if (optionsArray[optionIndex]) {
        if (optionsArray[optionIndex].isActive !== undefined) {
          return optionsArray[optionIndex].isActive ? optionsArray[optionIndex].option : ''
        }
        return optionsArray[optionIndex].option
      }
      return ''
    },

    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
        this.selectedClassID ||
        this.formData.trainingModuleID ||
        this.formData.durationMin ||
        this.formData.noOfQuestionsAppearForTest ||
        this.formData.attempts ||
        this.formData.description ||
        this.questionObj.question ||
        this.questionObj.description ||
        this.questionObj.options.some(option => option.option) ||
      this.questionObj.selectedOption
      return boolAlert
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/student/getclass-group`)
        this.isLoading = false
        data = _.filter(data, e => {
          return e.type === constants.ClassGroupTypes.teacherTraining && e.isActive === true
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    restoreItem: async function (item) {
      this.$dialog.error({
        color: 'warning',
        title: 'Restore Assessment ?',
        text: 'Do you want to Restore this Assessment?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              item.isActive = true
              this.okMsg(' Assessment Restored successfully!')
            }
          } }
      })
    },
    getAssessmentData: async function (assessmentID) {
      try {
        this.isLoading = true
        const result = await http.get(`${constants.API_URL}/api/teacher-training/assessment/get/${assessmentID}`)
        this.formData.trainingModuleID = result.data.trainingModule.id
        if (result.data.trainingModule.classID) {
          this.selectedClassID = result.data.trainingModule.classID
          await this.getModuleData()
        }
        this.formData.passingPercentage = Number(result.data.passingPercentage)
        this.formData.assessmentType = result.data.assessmentType
        this.formData.durationMin = result.data.durationMin
        this.formData.description = result.data.description
        this.formData.attempts = result.data.attempts
        this.formData.noOfQuestionsAppearForTest = result.data.noOfQuestionsAppearForTest
        if (!_.isEmpty(result.data.trainingQuestions)) {
          let maxOptions = 0
          for (let d of result.data.trainingQuestions) {
            d.trainingQuestionOptions = _.sortBy(d.trainingQuestionOptions, ['position']).map((item, index) => {
              item.position = index + 1
              return item
            })
            let correctOptions = _.filter(d.trainingQuestionOptions, val => {
              return val.isCorrect
            })
            d.selectedOption = correctOptions.map(option => option.position)

            const optionsLength = d.trainingQuestionOptions.length
            maxOptions = Math.max(maxOptions, optionsLength)
          }
          this.questions = result.data.trainingQuestions
          this.maxOptionsCount = maxOptions
        }
        result.data.trainingQuestions = _.sortBy(result.data.trainingQuestions, ['position'])
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    editItem (item) {
      if (this.isEdit) {
        return this.errMsg('Please add edited question')
      }
      this.isEdit = true
      if (item.id) {
        this.selectedID = item.id
        this.questionObj = item
        this.questionObj.options = item.trainingQuestionOptions.filter(option => {
          return option.isActive === true || option.isActive === undefined
        })
        this.questionObj.question = item.question
        this.questionObj.description = item.description
      } else {
        this.questionObj = item
      }
    },
    deleteItem: async function (item) {
      this.$dialog.error({
        title: 'Deactivate Assessment ?',
        text: 'Do you want to Deactivate this Assessment?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              item.isActive = false
              this.okMsg(' Assessment Deactivate successfully!')
            }
          }
        }
      })
    },
    getModuleData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/module/by-class/${this.selectedClassID}`)
        // const { data } = await http.get(`${constants.API_URL}/api/teacher-training/module/with-assessment?classID=${this.selectedClassID}`)
        this.moduleData = data
        this.isLoading = false
        await this.getClassList(this.selectedClassID)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassList: async function (classGroupID) {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`)
        this.mappingData = data
        let selectedClassObj = []
        if (this.mappingData) {
          const objectArray = Object.entries(this.mappingData)
          objectArray.forEach(([key, value]) => {
            value.studentClasses.map(function (k) {
              selectedClassObj.push(k.name)
            })
          })
          this.getList = selectedClassObj
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Class Group Mapping: ${errorMessage}`)
      }
    },
    setSelectedOption () {
      this.questionObj.options.forEach(d => {
        d.isCorrect = false
      })
      this.questionObj.selectedOption.forEach(selected => {
        this.questionObj.options.forEach(d => {
          if (d.position === selected) {
            d.isCorrect = true
          }
        })
      })
    },
    addQuestion () {
      let questionErr = false
      this.questionObj.question = this.questionObj.question.trim()
      this.questionObj.options = _.forEach(this.questionObj.options, val => val.option.trim())

      console.log(this.questionObj.options)
      if (!this.questionObj.question) {
        questionErr = true
        return this.errMsg('Empty/ blank data not allowed')
      }
      if (!this.questionObj.selectedOption) {
        return this.errMsg('Please Select correct option')
      }
      let chkEmptyOption = _.filter(this.questionObj.options, val => {
        return !val.option
      })
      if (!_.isEmpty(chkEmptyOption)) {
        questionErr = true
      }
      if (questionErr) {
        return this.errMsg('Fill all data for question.')
      } else {
        console.log('in else')
        if (this.isEdit) {
          console.log('restore')
          if (this.questionObj.trainingQuestionOptions) {
            const idx = this.questions.findIndex(q => q.id === this.questionObj.id)
            if (idx !== -1) {
              console.log('Before update:', this.questions[idx])
              this.questions[idx] = this.questionObj
              const currentOptions = this.questions[idx].trainingQuestionOptions
              const newOptions = this.questionObj.options
              if (currentOptions.length > newOptions.length) {
                this.questions[idx].trainingQuestionOptions = currentOptions.map((option, index) => {
                  if (index < newOptions.length) {
                    return {
                      ...option,
                      option: newOptions[index].option,
                      isCorrect: newOptions[index].isCorrect,
                      isActive: true

                    }
                  }
                  return { ...option,
                    isActive: false
                  }
                })
              } else if (currentOptions.length < newOptions.length) {
                this.questions[idx].trainingQuestionOptions = newOptions.map((newOption, index) => {
                  if (index < currentOptions.length) {
                    return {
                      ...currentOptions[index],
                      option: newOption.option,
                      isCorrect: newOption.isCorrect,
                      position: newOption.position,
                      isActive: true
                    }
                  } else {
                    return {
                      option: newOption.option,
                      isCorrect: newOption.isCorrect,
                      position: newOption.position,
                      questionID: this.questionObj.id }
                  }
                })
              }
            }
            this.questions[idx].trainingQuestionOptions = this.questions[idx].trainingQuestionOptions.filter(option =>
              !(option.isActive === false && option.id == null)
            )
            this.maxOptionsCount = this.questions.reduce((max, question) => {
              const optionsLength = question.trainingQuestionOptions
                ? question.trainingQuestionOptions.filter(option =>
                  option.isActive !== false
                ).length
                : 0
              return Math.max(max, optionsLength)
            }, 0)
            this.resetQuestion()
          }

          this.resetQuestion()
        } else {
          console.log('Adding new question')
          this.questionObj.position = this.questions.length + 1
          this.questions.push(this.questionObj)
          this.resetQuestion()
        }
      }
    },
    addOptions () {
      this.questionObj.selectedOption = ''
      const newPosition = this.questionObj.options.length + 1
      const newOption = {
        option: '',
        position: newPosition,
        isCorrect: false

      }
      this.questionObj.options = [...this.questionObj.options, newOption]
      this.updateCorrectOptions()
    },
    deleteOptions () {
      this.questionObj.selectedOption = ''
      if (this.questionObj.options.length > 2) {
        this.questionObj.options = this.questionObj.options.slice(0, -1)
        this.updateCorrectOptions()
      } else {
        this.$toast('No options left to delete', { type: 'warning' })
      }
    },
    updateCorrectOptions () {
      this.correctOption = this.questionObj.options.map((opt, index) => ({
        text: `${index + 1}`,
        value: index + 1
      }))
      this.questionObj.options.forEach((opt, idx) => {
        opt.position = idx + 1
      })
    },
    onSubmit: async function () {
      if (this.isEdit) {
        return this.errMsg('Please add edited question')
      }
      try {
        if (!this.valid) {
          return this.errMsg('Fill all form details')
        }
        let transection = null
        let message = null
        if (!this.assessmentID) {
          this.formData.questions = []
          this.formData.questions = this.questions.map(q => {
            return {
              ...q,
              hasMultipleAnswers: q.options.filter(opt => opt.isCorrect).length > 1 ? 1 : 0
            }
          })
          this.formData.questions = _.filter(this.formData.questions, d => {
            return d.isActive
          })
          this.formData.questions = _.map(this.formData.questions, object => _.omit(object, ['isActive', 'selectedOption']))
          if (_.isEmpty(this.formData.questions)) {
            return this.errMsg('Please add questions')
          } else {
            transection = http.post(`${constants.API_URL}/api/teacher-training/assessment/create`, this.formData)
          }
          message = 'Assessment added successfully!'
        } else {
          this.formData.id = this.assessmentID
          this.formData.trainingQuestions = []
          this.formData.questions = []
          _.map(this.questions, d => {
            if (d.id) {
              const hasMultipleAnswers = d.trainingQuestionOptions.filter(opt => opt.isCorrect).length > 1
              d.hasMultipleAnswers = hasMultipleAnswers ? 1 : 0
              this.formData.trainingQuestions.push(_.omit(d, ['selectedOption']))
            } else {
              if (d.isActive) {
                const hasMultipleAnswers = d.options.filter(opt => opt.isCorrect).length > 1
                d.hasMultipleAnswers = hasMultipleAnswers ? 1 : 0
                d.options = _.map(d.options, option => ({ ...option, option: option.option.trim() }))
                this.formData.questions.push(_.omit(d, ['isActive', 'selectedOption']))
              }
            }
          })
          this.formData.trainingQuestions = _.map(this.formData.trainingQuestions, object => _.omit(object, ['selectedOption', 'options']))
          this.formData.questions = _.map(this.formData.questions, object => _.omit(object, ['isActive', 'selectedOption']))
          if (!_.isEmpty(this.formData.trainingQuestions) || !_.isEmpty(this.formData.questions)) {
            transection = http.post(`${constants.API_URL}/api/teacher-training/assessment/update`, this.formData)
          } else {
            return this.errMsg('Please add questions')
          }
          message = 'Assessment updated successfully!'
        }
        if (transection) {
          this.isLoading = true
          await transection
          this.isLoading = false
          this.$buefy.dialog.alert({
            message: message,
            type: 'is-success'
          })
          this.$router.push({ name: 'teacherAssessment' })
        } else {
          return
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    resetQuestion () {
      this.isEdit = false
      this.selectedID = null
      this.questionObj = {
        question: '',
        description: '',
        isActive: true,
        position: '',
        selectedOption: '',
        options: [
          {
            option: '',
            position: 1,
            isCorrect: false
          },
          {
            option: '',
            position: 2,
            isCorrect: false
          },
          {
            option: '',
            position: 3,
            isCorrect: false
          },
          {
            option: '',
            position: 4,
            isCorrect: false
          }
        ]
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
#abcd{
  color:rgba(0,0,0,.6) ;
  font-size: 16px;
}
</style>
